import Sports from "@/assets/svg/creator-shield/bg-icons/basket-ball.svg";
import Media from "@/assets/svg/creator-shield/bg-icons/building.svg";
import Multi from "@/assets/svg/creator-shield/bg-icons/orange-building.svg";
import Studio from "@/assets/svg/creator-shield/bg-icons/recorder.svg";
import Agency from "@/assets/svg/creator-shield/bg-icons/talent-search.svg";
import { CSSecondaryBtn } from "@/components/design-system/creatorshield/CSButton";
import { Link } from "react-router-dom";

export default function ForMediaCompanies() {
  const services = [
    {
      icon: Agency,
      title: "For talent agencies",
      top: "28px",
    },
    {
      icon: Sports,
      title: "For sports networks",
      top: "189px",
    },
    {
      icon: Studio,
      title: "For TV, film, and animation studios",
      top: "350px",
    },
    {
      icon: Media,
      title: "For media companies",
      top: "511px",
    },
    {
      icon: Multi,
      title: "For multi-channel networks",
      top: "672px",
    },
  ];

  const decorativeIcons = [
    {
      icon: Agency,
      left: "calc(50% - 561.23px)",
      top: "calc(50% - 314.23px)",
      size: 90,
    },
    { icon: Sports, left: "calc(50% - 740.5px)", top: "249px", size: 93 },
    { icon: Studio, left: "calc(50% - 566.72px)", top: "716px", size: 90 },
    { icon: Media, left: "calc(50% - 238.24px)", top: "634px", size: 85 },
    {
      icon: Studio,
      left: "calc(50% - 234.37px)",
      top: "calc(50% - 217.37px)",
      size: 87,
    },
  ];

  const servicesWithPositions = [
    {
      icon: Agency,
      title: "For talent agencies",
      left: {
        xxs: "calc(50% + 200px)",
        lg: "calc(50% + 200px)",
        xl: "calc(50% + 250px)",
        "2xl": "calc(50% + 307px)",
      },
      top: { xxs: "28px", lg: "28px", xl: "28px", "2xl": "28px" },
      textPadding: { xxs: "16px", lg: "16px", xl: "16px", "2xl": "16px" },
    },
    {
      icon: Sports,
      title: "For sports networks",
      left: {
        xxs: "calc(50% + 320px)",
        lg: "calc(50% + 320px)",
        xl: "calc(50% + 450px)",
        "2xl": "calc(50% + 526px)",
      },
      top: { xxs: "189px", lg: "189px", xl: "189px", "2xl": "189px" },
      textPadding: { xxs: "16px", lg: "16px", xl: "1px", "2xl": "1px" },
    },
    {
      icon: Studio,
      title: "For TV, film, and animation studios",
      left: {
        xxs: "calc(50% + 200px)",
        lg: "calc(50% + 200px)",
        xl: "calc(50% + 250px)",
        "2xl": "calc(50% + 307px)",
      },
      top: { xxs: "350px", lg: "350px", xl: "350px", "2xl": "350px" },
      textPadding: { xxs: "16px", lg: "16px", xl: "16px", "2xl": "16px" },
    },
    {
      icon: Media,
      title: "For media companies",
      left: {
        xxs: "calc(50% + 320px)",
        lg: "calc(50% + 320px)",
        xl: "calc(50% + 450px)",
        "2xl": "calc(50% + 526px)",
      },
      top: { xxs: "511px", lg: "511px", xl: "511px", "2xl": "511px" },
      textPadding: { xxs: "4px", lg: "4px", xl: "1px", "2xl": "1px" },
    },
    {
      icon: Multi,
      title: "For multi-channel networks",
      left: {
        xxs: "calc(50% + 220px)",
        lg: "calc(50% + 220px)",
        xl: "calc(50% + 250px)",
        "2xl": "calc(50% + 329px)",
      },
      top: { xxs: "672px", lg: "672px", xl: "672px", "2xl": "672px" },
      textPadding: { xxs: "16px", lg: "16px", xl: "16px", "2xl": "16px" },
    },
  ];

  return (
    <div
      id="for-media-companies"
      className="bg-[#FF6B35] py-20 lg:py-0 px-6 md:px-16 relative overflow-hidden min-h-[860px]"
    >
      <div className="4xl:max-w-[100rem] 4xl:mx-auto relative min-h-[800px]">
        {/* Left Side - Text Content */}
        <div className="absolute hidden lg:flex flex-col gap-[22px] items-start justify-center lg:left-[calc(50%-200.5px)] xl:left-[calc(50%-280px)] 2xl:left-[calc(50%-410px)] 1xl:left-[calc(50%-400px)] top-1/2 translate-x-[-50%] translate-y-[-50%] 4xl:left-[calc(50%-510px)] max-w-[500px] xl:max-w-[600px] 2xl:max-w-[700px] 1xl:max-w-[800px]">
          <p className="text-white font-semibold text-xl uppercase tracking-wide">
            FOR MEDIA COMPANIES
          </p>
          <div className="flex flex-col gap-0">
            <h2 className="text-4xl md:text-5xl lg:text-7xl font-semibold text-white ">
              Protect your
            </h2>
            <h2 className="text-4xl md:text-5xl lg:text-7xl font-semibold text-white ">
              roster & catalog
            </h2>
          </div>
          <div className="text-lg text-white font-normal leading-[30px]">
            <p className="mb-0">
              Whether you license UGC or manage a roster of talent,
            </p>
            <p className="mb-0">
              CreatorShield is the perfect{" "}
              <span className="font-semibold">all-in-one</span> fit
            </p>
          </div>
          <Link to="/contact-us">
            <CSSecondaryBtn
              name="Contact enterprise"
              className="px-[35px] py-3 rounded-[5px] w-fit !z-50"
            />
          </Link>
        </div>

        {/* Right Side - Service Cards (Desktop) */}
        {servicesWithPositions.map((service, index) => {
          const IconSrc = service.icon;

          return (
            <div key={index}>
              {/* Dynamic positioning styles - only for left, top, and textPadding values */}
              <style>{`
                @media (min-width: 320px) and (max-width: 1023px) {
                  #service-card-${index} {
                    left: ${service.left.xxs || service.left.lg} !important;
                    top: ${service.top.xxs || service.top.lg} !important;
                  }
                  #service-text-${index} {
                    padding-left: ${service.textPadding?.xxs || service.textPadding?.lg || "16px"} !important;
                    padding-right: ${service.textPadding?.xxs || service.textPadding?.lg || "16px"} !important;
                  }
                }
                @media (min-width: 1024px) {
                  #service-card-${index} {
                    left: ${service.left.lg} !important;
                    top: ${service.top.lg} !important;
                  }
                  #service-text-${index} {
                    padding-left: ${service.textPadding?.lg || "16px"} !important;
                    padding-right: ${service.textPadding?.lg || "16px"} !important;
                  }
                }
                @media (min-width: 1280px) {
                  #service-card-${index} {
                    left: ${service.left.xl} !important;
                    top: ${service.top.xl} !important;  
                  }
                  #service-text-${index} {
                    padding-left: ${service.textPadding?.xl || "16px"} !important;
                    padding-right: ${service.textPadding?.xl || "16px"} !important;
                  }
                }
                @media (min-width: 1536px) {
                  #service-card-${index} {
                    left: ${service.left["2xl"]} !important;
                    top: ${service.top["2xl"]} !important;
                  }
                  #service-text-${index} {
                    padding-left: ${service.textPadding?.["2xl"] || "16px"} !important;
                    padding-right: ${service.textPadding?.["2xl"] || "16px"} !important;
                  }
                }
              `}</style>
              {/* Note: Cards are hidden below lg (1024px). To see xxs styles, change 'hidden lg:block' to 'block' or 'xxs:block' */}
              <div
                id={`service-card-${index}`}
                className="absolute h-[160px] hidden lg:block w-[480px] xl:w-[520px] 2xl:w-[548px]"
                style={{
                  transform: "translateX(-50%)",
                }}
              >
                {/* Circular Icon */}
                <div
                  id={`service-icon-${index}`}
                  className="absolute bg-white rounded-full flex items-center justify-center overflow-hidden z-30 left-16 xl:left-[72px] 2xl:left-20 w-[140px] h-[140px] xl:w-[150px] xl:h-[150px] 2xl:w-[158px] 2xl:h-40"
                >
                  <img
                    id={`service-icon-img-${index}`}
                    src={IconSrc}
                    alt=""
                    className="w-20 h-20 xl:w-[85px] xl:h-[85px] 2xl:w-[90px] 2xl:h-[90px] object-cover rounded-full"
                  />
                </div>

                {/* Text Card */}
                <div
                  id={`service-text-card-${index}`}
                  className="absolute bg-white border border-[#ddd] rounded-[20px] h-[95px] flex items-center justify-start z-0 left-40 xl:left-[170px] 2xl:left-[190px] w-[400px] xl:w-[430px] 2xl:w-[458px] top-6 xl:top-[33px] 2xl:top-[33px] pl-16 xl:pl-[72px] 2xl:pl-20"
                >
                  <p
                    id={`service-text-${index}`}
                    className="font-semibold text-black text-left text-lg xl:text-xl 2xl:text-2xl"
                  >
                    {service.title}
                  </p>
                </div>
              </div>
            </div>
          );
        })}

        {/* Mobile Layout */}
        <div className="lg:hidden flex flex-col items-center">
          <div className="flex flex-col gap-[22px] items-center text-center mb-12">
            <p className="text-white font-semibold text-xl uppercase tracking-wide ">
              FOR MEDIA COMPANIES
            </p>
            <div className="text-[80px] font-semibold leading-[normal] text-center text-white">
              <p className="mb-0">Protect your</p>
              <p>roster & catalog</p>
            </div>
            <div className="text-lg text-white font-normal leading-[30px] max-w-[458px]">
              <p className="mb-0">
                Whether you license UGC or manage a roster of talent,
              </p>
              <p className="mb-0">
                CreatorShield is the perfect{" "}
                <span className="font-semibold">all-in-one</span> fit
              </p>
            </div>
            <Link to="/contact-us" className="relative z-50">
              <CSSecondaryBtn 
                name="Contact enterprise" 
                className="px-[35px] py-3 rounded-[5px] w-fit"
              />
            </Link>
          </div>
          <div className="flex flex-col gap-6 w-full max-w-[548px] items-center ">
            {services.map((service, index) => {
              const IconSrc = service.icon;
              // 2nd and 4th items (index 1 and 3) are offset to the right
              const leftOffset =
                index === 1 || index === 3 ? "left-[50px]" : "left-0";
              const textCardLeft =
                index === 1 || index === 3 ? "left-[159px]" : "left-[90px]";
              return (
                <div key={index} className="relative h-[160px] w-full">
                  {/* Circular Icon */}
                  <div
                    className={`absolute ${leftOffset} top-2 w-[145px] h-[145px] bg-white rounded-full flex items-center justify-center overflow-hidden z-30`}
                  >
                    <img src={IconSrc} alt="" className="w-[90px] h-[90px]" />
                  </div>

                  {/* Text Card */}
                  <div
                    className={`absolute ${textCardLeft} bg-white border-[#ddd] border-[0.5px] rounded-[20px] h-[95px] w-[458px] top-[33px] flex items-center justify-start`}
                  >
                    <p className="text-base font-semibold text-black text-left max-w-52 pl-14">
                      {service.title}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Decorative Background Icons */}
        {decorativeIcons.map((dec, index) => {
          const IconSrc = dec.icon;
          // Hide Sports icon
          if (IconSrc === Sports) return null;
          return (
            <div
              key={`dec-${index}`}
              className="absolute hidden xl:block opacity-20"
              style={{
                left: dec.left,
                top: dec.top,
                width: `${dec.size}px`,
                height: `${dec.size}px`,
              }}
            >
              <img src={IconSrc} alt="" className="w-full h-full" />
            </div>
          );
        })}
      </div>
    </div>
  );
}
